import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import {
  Box,
  Dialog,
  ListItem,
  List,
  ListItemText,
  DialogTitle,
} from "@mui/material";
import DynamicTable from "../../Utils/DynamicTable";
// import AddShortlist from "./addshortlist";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import { fetchAll, deleteItem, postItem } from "../../../BaseUrl";
import { invoiceeligibleCandidate, invoiceeligibleFilter } from "./mutation";
import axios from "axios";
import LoadingSpinner from "../../loader/loadercomp";
import MaterialTypography from "../../../components/MaterialTypography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import AccessComponent from "../../Utils/AccessComponent";
import ExportDialog from "../../Utils/ExportDialog";
import Onboarded from "../onboard/onboard";
import { UserContext } from "../../usercontext/usercontext";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function InvoiceEligible() {
  const { user,isuser } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [userlist, setuserlist] = useState([]);
  const [differences, setDifferences] = useState([]);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [openExport, setOpenExport] = useState(false);
  const [Loader, setLoader] = useState(false);

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [userdata, setuserdata] = useState({
    firstname: "",
    lastname: "",
    gender: "",
    role: "",
    leader: "",
    clients: "",
    language: "",
    mail: "",
    address: "",
    countrycode: "",
    contactno: "",
    primaryconno: "",
    primarycode: "",
    dob: "",
    username: "",
    password: "",
    firstnameStatus: "",
    lastnameStatus: "",
    genderStatus: "",
    roleStatus: "",
    leaderStatus: "",
    clientsStatus: "",
    languageStatus: "",
    mailStatus: "",
    addressStatus: "",
    countrycodeStatus: "",
    contactnoStatus: "",
    primaryconnoStatus: "",
    primarycodeStatus: "",
    dobStatus: "",
    usernameStatus: "",
    passwordStatus: "",
  });

  const [countryState, setCountryState] = useState({
    countries: [],
    countryCodes: [],
    states: [],
    selectedCountryCode: null,
    selectedCountry: null,
    selectedState: null,
  });
  const [dialogOpen, setDialogOpen] = useState(false);

  const [roleoptions, setroleoptions] = useState([]);
  const [leaderoptions, setleaderoptions] = useState([]);
  const [clientoptions, setclientoptions] = useState([]);
  const [sortedvalue, setsortedvalue] = useState("");

  const columns = [
    { label: "Candidate Name", field: "candidateName" },
    { label: "Candidate Number", field: "candidateNumber" },
    { label: "Status", field: "status" },
    { label: "Onboarded Date", field: "onboardDate" },
    { label: "Actions", field: "actions" },
  ];

  const [searchdata, setsearchdata] = useState("");

  const validIndustryData = Array.isArray(userlist) ? userlist : [];

  const filteredData =
    searchdata.length > 2
      ? validIndustryData.filter((lesson) => {
          const lowerTerm = searchdata.toLowerCase();
          return Object.entries(lesson).some(
            ([key, value]) =>
              typeof value === "string" &&
              value.toLowerCase().includes(lowerTerm)
          );
        })
      : [];

  const sortedData =
    searchdata.length > 2
      ? filteredData
      : [...validIndustryData].sort((a, b) => {
          const sortOption = sortedvalue?.value || "descending"; // default to descending
          switch (sortOption) {
            case "ascending":
              return new Date(a.createdAt) - new Date(b.createdAt);
            case "descending":
              return new Date(b.createdAt) - new Date(a.createdAt);
            default:
              return validIndustryData; // default to descending
          }
        });

  useEffect(() => {
    getALluserdetail();
  }, []);

  const getALluserdetail = async () => {
    try {
      const variables = {
        hr_user_id: parseInt(isuser.userid),
      };

      if (user.roleName === "Admin") {
        const response = await fetchAll(invoiceeligibleCandidate);
        if (response?.allInvoiceEligibleCandidates?.success === true) {
          setuserlist(response?.allInvoiceEligibleCandidates.dataList);
        } else {
          setuserlist([]);
        }
      } else {
        const response = await postItem(invoiceeligibleFilter, variables);
        if (response?.invoiceEligibleCandidatesByHr?.success === true) {
          setuserlist(response?.invoiceEligibleCandidatesByHr.dataList);
        } else {
          setuserlist([]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const exportData = sortedData.map((item) => ({
    id: item.id,
    candidateName: item.candidateName || "N/A",
    candidateNumber: item.candidateNumber || "N/A",
    positionName: item.position?.positionName || "N/A",
    jobDescription: item.position?.jopDescription || "N/A",
    clientName: item.client?.clientName || "N/A",
    status: item.status || "N/A",
    feedback: item.feedback || "N/A",
    date: formatDate(item.date),
    invoiceEligible: item.isInvoiceEligible == true ? "Yes" : "N/A",
    OnboardedDate: formatDate(item.onboardDate),
    createdBy: item.createdBy || "N/A",
    createdAt: formatDate(item.createdAt),
    updatedAt: formatDate(item.updatedAt),
    updatedBy: item.updatedBy || "N/A",
  }));

  const formClose = () => {
    setOpen(false);
  };
  const addRole = () => {
    setOpen(true);
  };

  const exportClose = () => {
    setOpenExport(false);
  };

  const onView = (id) => {
    let diff = userlist.filter((x) => x.id == id);
    setOpen(true);
    setDifferences(diff);
  };

  const onEdit = () => {
    setOpen(true);
  };

  const onDelete = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete Course ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteRole(id),
    });
  };

  //delete api call
  const deleteRole = async (id) => {
    handleCloseDialog();
  };
  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const handleCloseview = () => {
    setOpen(false);
    setDifferences([]);
  };

  return (
    <DashboardLayout
      setOpenExport={setOpenExport}
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      name="Invoice Eligible Candidates"
    >
      {Loader && <LoadingSpinner />}
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={exportData}
        fileName="Invoice_ELigible"
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiDialog-paper": {
            width: "800px", // Set your desired width
            maxWidth: "none", // Prevent it from limiting the width to default sizes
          },
        }}
      >
        <Box p={3}>
          {" "}
          {/* Add padding here for spacing */}
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "1%",
              marginBottom: "1%",
            }}
          >
            <CloseIcon onClick={handleCloseview} sx={{ cursor: "pointer" }} />
          </div>
          <h4 style={{ textAlign: "center" }}>
            <DialogTitle
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                color: "#000",
              }}
            >
              View Details
            </DialogTitle>
          </h4>
          <List dense>
            {differences.length > 0 ? (
              differences.map((change, index) => (
                <ListItem
                  key={index}
                  alignItems="flex-start"
                  sx={{ alignItems: "flex-start", mb: 1 }} // optional spacing between items
                >
                  <ListItemText
                    primary={
                      <MaterialTypography
                        fontWeight="600"
                        sx={{ color: colors.inputlabel }}
                      >
                        {change.field}
                      </MaterialTypography>
                    }
                    secondary={
                      <>
                        <MaterialTypography variant="body2">
                          <strong>Client:</strong>
                          {change.client.clientName}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>Candidate Name:</strong>
                          {change.candidateName}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>Candidate Number:</strong>
                          {change.candidateNumber}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>Invoice Eligible:</strong>
                          {change.isInvoiceEligible == true ? "Yes" : "NO"}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>OnBoarded On:</strong>
                          {change.onboardDate}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>Position:</strong>
                          {change.position.positionName}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>HR:</strong>
                          {change.hrUser.username}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>Feedback:</strong>
                          {change.feedback}
                        </MaterialTypography>
                        <MaterialTypography variant="body2">
                          <strong>Status:</strong>
                          {change.status}
                        </MaterialTypography>
                      </>
                    }
                  />
                </ListItem>
              ))
            ) : (
              <MaterialTypography>No differences found.</MaterialTypography>
            )}
          </List>
        </Box>
      </Dialog>
      <DynamicTable
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={onDelete}
        name="Invoice Eligible Candidates"
      />
    </DashboardLayout>
  );
}

export default InvoiceEligible;
